import { Content } from '@prismicio/client';
import styles from './ourProcessHeroCards.module.scss';
import type { Simplify } from '../../../../../../prismicio-types';
import { OurProcessPhotoCard } from './OurProcessPhotoCard/OurProcessPhotoCard';
import { OurProcessTextCard } from './OurProcessTextCard/OurProcessTextCard';

interface OurProcessHeroCardsProps {
  data: Simplify<Content.HeroSliceOurProcessPrimary>;
  isVisible: boolean;
}

export const OurProcessHeroCards = ({
  data,
  isVisible,
}: OurProcessHeroCardsProps) => {
  return (
    <article className={styles.cards_wrapper}>
      <div className={`${styles.column} ${styles.column_1}`}>
        <OurProcessPhotoCard
          image={data.first_column_photo}
          styles={styles.photo_card_1}
          isVisible={isVisible}
        />
        <OurProcessTextCard
          items={data.first_column_text_card}
          isVisible={isVisible}
        />
      </div>
      <div className={`${styles.column} ${styles.column_2}`}>
        <OurProcessTextCard
          items={data.second_column_text_card}
          isVisible={isVisible}
        />
        <OurProcessPhotoCard
          image={data.second_column_photo}
          styles={styles.photo_card_2}
          isVisible={isVisible}
        />
      </div>
    </article>
  );
};
